// removed by extract-text-webpack-plugin
module.exports = {"closeButton":"src-components-IbcArcade-PriceCards----styles-module---closeButton---2Dq3v","dialogStyle":"src-components-IbcArcade-PriceCards----styles-module---dialogStyle---3aO7t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IbcArcade/PriceCards/styles.module.scss
// module id = 270
// module chunks = 83859446858435 221169179872205